// ── BCH Faucet Configuration ──────────────────────────────────────

// Faucet wallet — operator sends from Cashonize
export const FAUCET_WALLET = 'bitcoincash:qzfczm3kc9j8aw0pjm5azym8s8xg07ssru5yr5qepj';

// Nostr event tracking
export const FAUCET_CLAIM_KIND = 30078;
export const FAUCET_D_TAG = 'bchnostr/faucet-claim';
export const FAUCET_TAG = 'bch-faucet';

// ── One-time faucet (onboarding) ─────────────────────────────────
export const FAUCET_TIERS = [
  { minTips: 10, reward: 50000, label: 'Power Tipper', emoji: '\u{1F525}' },
  { minTips: 5, reward: 25000, label: 'Active Tipper', emoji: '\u{2B50}' },
  { minTips: 3, reward: 10000, label: 'First Tipper', emoji: '\u{1F4A7}' },
];

// Minimum account age in seconds (7 days)
export const MIN_ACCOUNT_AGE = 7 * 86400;

export function getRewardTier(tipCount: number): typeof FAUCET_TIERS[0] | null {
  for (const tier of FAUCET_TIERS) {
    if (tipCount >= tier.minTips) return tier;
  }
  return null;
}

// ── Loyalty rewards (biweekly, recurring) ─────────────────────────
export const LOYALTY_D_TAG = 'bchnostr/loyalty-claim-v2';
export const LOYALTY_TAG = 'bch-loyalty';
export const LOYALTY_CLAIM_KIND = 30078;
export const LOYALTY_PERIOD_DAYS = 14;          // claim every 2 weeks
export const LOYALTY_MIN_TIP_SATS = 100;        // ~$0.05 min tip to qualify
export const LOYALTY_MIN_TIPS_REQUIRED = 2;     // must tip 2+ unique users in the period
export const LOYALTY_MIN_POSTS_REQUIRED = 1;    // must post 1+ note in the period

export const LOYALTY_TIERS = [
  { minTips: 5, reward: 10000, label: 'Very Active', emoji: '\u{1F31F}' },
  { minTips: 2, reward: 5000, label: 'Active', emoji: '\u{1F4AA}' },
];

export function getLoyaltyTier(recentTipCount: number): typeof LOYALTY_TIERS[0] | null {
  for (const tier of LOYALTY_TIERS) {
    if (recentTipCount >= tier.minTips) return tier;
  }
  return null;
}

